export const MOCK_DATA = {
  USER: {
    id: 1,
    userID: 'cheeze123',
    image:
      'https://images.unsplash.com/photo-1566496875470-68ada46a38c5?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170',
    userId: 'cheeze123',
  },
  BOARD: {
    id: 1,
    name: '바닷가',
    pinList: [],
  },
};
